import { defaultTheme } from '@themes/index.js';

var cachedTheme = null;

export const createTheme = () => {
  if (cachedTheme) return cachedTheme;

  cachedTheme = defaultTheme;
  return cachedTheme;
};

export default createTheme;
